export default "__VITE_ASSET__DRePdWw4__"